import PulseLoader from "@hudson/ui/components/Loader/PulseLoader";
import { getProfiles } from "@lib/auth/jwt";
import FrameConfig from "@lib/classes/FrameConfig";
import logoutProfile from "@lib/services/logout_profile";
import Session from "@lib/session";
import useConfig from "@lib/use_config";
import useContent from "@lib/use_content";
import classNames from "classnames";
import { useState } from "react";
import regexifyString from "regexify-string";

function LogoutGroup({}): JSX.Element | null {
  const { data, loading } = useContent(["beGroupLogoutLabel", "groupName", "charterName"]);
  const { data: configData, loading: configLoading } = useConfig([
    "lockGroupProfile",
    "hideGroupProfileActions",
  ]);
  const [loggingOut, setLoggingOut] = useState(false);

  if (!getProfiles().group && !getProfiles().charter) return null;

  const charterLoggedIn = getProfiles().charter;

  let logoutGroupLabel = regexifyString({
    pattern: /_CODE_/gi,
    decorator: (match: string, index: number) => (
      <span key={index} className="font-extrabold" style={{ color: "var(--primary-color)" }}>
        {charterLoggedIn ? data?.content.charterName : data?.content.groupName}
      </span>
    ),
    input: data?.content.beGroupLogoutLabel,
  });

  async function logoutGroup() {
    setLoggingOut(true);
    await logoutProfile(charterLoggedIn ? "CHARTER" : "GROUP");
    await Session.clearSession();
    window.location.href = `${process.env.basePath}/${window.siteId}/book`;
  }

  const frameConfig = new FrameConfig();
  const isClientCenter = frameConfig.mode?.toUpperCase() === "CLIENTCENTER";
  const locked =
    !charterLoggedIn &&
    (frameConfig.lockGroupProfile || configData?.config.lockGroupProfile);

  if (loading || configLoading) return null;

  if (configData?.config.hideGroupProfileActions && !isClientCenter) return null;

  if (locked || isClientCenter) {
    const groupName = charterLoggedIn ? data?.content.charterName : data?.content.groupName;
    if (!groupName) return null;
    return (
      <div className="flex items-center mx-2 my-2">
        <span className="font-extrabold" style={{ color: "var(--primary-color)" }}>
          {groupName}
        </span>
      </div>
    );
  }

  return (
    <div className="flex items-center">
      <a
        href="#"
        className={classNames("hover:opacity-75", { "opacity-75": loggingOut })}
        onClick={logoutGroup}
      >
        {logoutGroupLabel}
      </a>
      {loggingOut && <PulseLoader size={1} className="pl-1" />}
    </div>
  );
}

export default LogoutGroup;
